import { signal, Service } from '@angular/core';

@Service()
export class MessageService {
	messages = signal<{ id: number; text: string; type: string }[]>([]);

	show(text: string, type: 'alert-info' | 'alert-success' | 'alert-error' | 'alert-warning' = 'alert-info'): void {
		const id = Date.now();
		this.messages.update((m) => [...m, { id, text, type }]);

		setTimeout(() => {
			this.messages.update((m) => m.filter((msg) => msg.id !== id));
		}, 5000);
	}

	showServerError(error: any): void {
		const errorMessage = error?.error?.message || error?.error?.errors || error?.error?.data || error?.error || error?.statusText;
		const text = Array.isArray(errorMessage) ? errorMessage.join('\n') : errorMessage;
		this.show(text, 'alert-error');
		console.error(error);
	}

	vibrate(): void {
		window.navigator.vibrate([600, 300, 600]);
	}
}
